module.exports = __webpack_public_path__ + "img/Oman_logo_ramadan_en-portrait.430e8344.png";